<template>
  <v-list-item v-if="!isEditing" ripple class="it-hv">
    <v-list-item-avatar class="my-0"><v-icon small>fal fa-birthday-cake</v-icon></v-list-item-avatar>
    <v-list-item-content>
      <v-list-item-subtitle class="caption" v-if="!isPrintEmpty">生年月日</v-list-item-subtitle>
      <v-list-item-title>{{ printBirthday }} {{ printAge }}</v-list-item-title>
    </v-list-item-content>
    <v-list-item-action>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" color="secondary" :loading="isThisLoading" @click="edit">
            <v-icon small>fal fa-pencil</v-icon>
          </v-btn>
        </template>
        <span>編集する</span>
      </v-tooltip>
    </v-list-item-action>
  </v-list-item>
  <v-container v-else>
    <v-row dense class="pb-4">
      <v-col cols="12" class="px-3">
        <v-menu lazy offset-y full-width
          v-model="config.datepicker.birthday"
          transition="scale-transition"
          min-width="290px"
          :close-on-content-click="false">
          <template v-slot:activator="{ on }">
            <v-text-field readonly required
              v-model="printFormatedBirthday"
              :rules="rules.birthday"
              label="生年月日"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            ref="picker"
            v-model="form.birthday.content"
            color="amber"
            locale="ja"
            :max="new Date().toISOString().substr(0, 10)"
            min="1950-01-01"
            :day-format="date => new Date(date).getUTCDate()"
            @input="config.datepicker.birthday = false"
          />
        </v-menu>
      </v-col>
    </v-row>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
export default {
  name: 'clientAboutBasicBirthday',
  props: [
    'status',
    'data'
  ],
  data () {
    return {
      config: {
        datepicker: {
          birthday: false
        }
      },
      form: {
        birthday: {
          id: '',
          content: ''
        }
      },
      rules: {
        birthday: [
          v => !!v || '必須項目です'
        ]
      }
    }
  },
  watch: {
    'config.datepicker.birthday': function (val) {
      val && setTimeout(() => { this.$refs.picker.activePicker = 'YEAR' })
    }
  },
  methods: {
    prepare: function () {
      if (
        this.$props.data &&
        this.$props.data.birthday
      ) {
        this.$set(this.form, 'birthday', {
          id: '' + (this.$props.data.birthday.id ? this.$props.data.birthday.id : 'new_birthday'),
          content: this.$props.data.birthday.content ? this.$moment(this.$props.data.birthday.content).format('YYYY-MM-DD') : ''
        })
      } else {
        this.$set(this.form, 'birthday', {
          id: 'new_birthday',
          content: ''
        })
      }
    },
    edit: function () {
      this.prepare()
      this.$emit('emit', {
        action: 'edit',
        data: {
          type: 'birthday'
        }
      })
    },
    getForm: function () {
      return this.form
    }
  },
  computed: {
    isEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        ['birthday', 'all'].includes(this.$props.status.editing)
      )
    },
    isThisEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        this.$props.status.editing === 'birthday'
      )
    },
    isLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        ['birthday', 'all'].includes(this.$props.status.loading)
      )
    },
    isThisLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        this.$props.status.loading === 'birthday'
      )
    },
    isPrintEmpty () {
      return !(
        this.$props &&
        this.$props.data &&
        this.$props.data.birthday &&
        this.$props.data.birthday.content
      )
    },
    printBirthday () {
      return (
        this.$props &&
        this.$props.data &&
        this.$props.data.birthday &&
        this.$props.data.birthday.content
      ) ? this.$moment(this.$props.data.birthday.content).format('YYYY/MM/DD') : '生年月日'
    },
    printFormatedBirthday () {
      return (
        this.form &&
        this.form.birthday &&
        this.form.birthday.content
      ) ? this.$moment(this.form.birthday.content).format('YYYY/MM/DD') : ''
    },
    printAge () {
      if (
        this.$props &&
        this.$props.data &&
        this.$props.data.birthday &&
        this.$props.data.birthday.content
      ) {
        let dts = this.$moment(this.$props.data.birthday.content)
        let today = [
          new Date().getFullYear(),
          new Date().getMonth() + 1,
          new Date().getDate()
        ]
        return ([
          '（',
          today[0] - dts.year() + (
            (
              (today[1] > (dts.month() + 1)) ||
              ((today[1] === (dts.month() + 1)) && today[2] >= dts.date())
            ) ? 0 : -1
          ),
          '歳）'
        ].join(''))
      } else {
        return ''
      }
    }
  }
}
</script>
